"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCurrency = formatCurrency;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/trim"));
var _formatStringFromNumber = require("./format-string-from-number");
var CURRENCY_SYMBOL_POSITION = /*#__PURE__*/function (CURRENCY_SYMBOL_POSITION) {
  CURRENCY_SYMBOL_POSITION[CURRENCY_SYMBOL_POSITION["PRE_FIXED"] = 0] = "PRE_FIXED";
  CURRENCY_SYMBOL_POSITION[CURRENCY_SYMBOL_POSITION["POST_FIXED"] = 1] = "POST_FIXED";
  return CURRENCY_SYMBOL_POSITION;
}(CURRENCY_SYMBOL_POSITION || {});
function getCurrencySymbol(currencySymbol, companyDefaultCurrencySymbol) {
  const defaultSymbol = '$';
  const computedSymbol = typeof currencySymbol === 'string' && currencySymbol.length > 0 ? currencySymbol : companyDefaultCurrencySymbol;
  return computedSymbol || defaultSymbol;
}
function getCurrencyCode(currencyCode, companyDefaultCurrencyCode) {
  const computedCode = typeof currencyCode === 'string' && currencyCode.length > 0 ? currencyCode : companyDefaultCurrencyCode;
  return computedCode || '';
}
function formatCurrency(value, options) {
  var _context;
  const {
    amount,
    code: currencyCode,
    decodedSymbol,
    symbolPosition = CURRENCY_SYMBOL_POSITION.PRE_FIXED
  } = value;
  const formattedAmount = (0, _formatStringFromNumber.formatStringFromNumber)(amount, options?.decimalPointChar, options?.thousandsSeparatorChar);
  const amountWithSymbol = CURRENCY_SYMBOL_POSITION.PRE_FIXED === symbolPosition ? `${getCurrencySymbol(decodedSymbol, options?.companyDefaultCurrencySymbol)}${formattedAmount.toString()}` : `${formattedAmount.toString()}${getCurrencySymbol(decodedSymbol, options?.companyDefaultCurrencySymbol)}`;
  return options?.includeCurrencyCode ? (0, _trim.default)(_context = `${amountWithSymbol} ${getCurrencyCode(currencyCode, options?.companyDefaultCurrencyCode)}`).call(_context) : amountWithSymbol;
}